import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { gsap } from 'gsap'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'bricks-and-beam';

  ngOnInit(): void {
    this.scroll();
  }

  scroll() {
    gsap.to("#testimonials", {
      // x:400,
      // rotation: 360,
      // y:400,
      duration: 3
    })
  }
}
